/* Create action types */
import createActionTypes from '../createActionTypes';

export const SET_FILTERS = createActionTypes('SET_FILTERS');
